import axios from 'axios'
import { ElMessage } from 'element-plus'

// 创建axios实例
const request = axios.create({
  baseURL: '/api',  // 添加回/api前缀，因为后端有context path
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json'
  }
})

console.log('request.js axios实例已创建:', request);

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    console.log('发送请求:', config.method?.toUpperCase(), config.url)
    return config
  },
  error => {
    // 对请求错误做些什么
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    // 如果是二进制数据，直接返回
    if (response.config.responseType === 'blob') {
      return response.data;
    }
    
    // 对响应数据做点什么
    const { data } = response
    
    // 兼容后端直接返回数组的情况
    if (Array.isArray(data)) {
      return data;
    }
    
    // 如果是成功响应，显示成功消息并返回数据
    if (data.success || data.code === 200) {
      // 只有当请求不是GET类型且未设置suppressAutoSuccess时，才显示成功提示
      if (response.config.method !== 'get' && !response.config.suppressAutoSuccess) {
        let msg = data.message
        if (!msg || msg === 'success') msg = '操作成功'
        ElMessage.success(msg)
      }
      return data
    }
    
    // 如果是错误响应，抛出错误
    const error = new Error(data.message || '请求失败')
    error.code = data.code
    if (!response.config?.suppressAutoError) {
    ElMessage.error(error.message)
    }
    return Promise.reject(error)
  },
  error => {
    // 对响应错误做点什么
    console.error('响应错误:', error)
    
    let message = '网络错误'
    if (error.response) {
      // 服务器响应了错误状态码
      message = error.response.data?.message || `服务器错误 ${error.response.status}`
    } else if (error.request) {
      // 请求已发出但没有收到响应
      message = '网络连接失败，请检查网络'
    }
    
    // 显示错误消息
    ElMessage.error(message)
    
    return Promise.reject(error)
  }
)

export default request 